<template>
  <div>
    <div>
      <van-nav-bar
        title="单场数据"
        left-text="返回"
        left-arrow
        @click-left="onTopClickLeft"
      >
        <a
          :href="
            routeValue === null ||
            routeValue === undefined ||
            routeValue.length === 0
              ? 'https://www.ptty.com.cn/wap/#/'
              : 'https://www.ptty.com.cn/wap/#/' + routeValue
          "
          slot="right"
          style="font-size:20px;"
        >
          <van-icon style="font-size:20px;" name="wap-home" />
        </a>
      </van-nav-bar>
    </div>
    <div style="margin-top:80px"></div>
    <div v-for="(mainItem, mainIndex) in dataList" :key="mainIndex">
      <div v-if="mainItem.MXLIST[0].SSLXTYPE === 'T'">
        <!-- 团体赛 开始 -->
        <div
          style="background: #fff;margin-left: 10px;margin-right: 10px;margin-top: 20px;border-radius: 5px;"
        >
          <div
            class="titleMainClass"
            v-bind:style="{
              background:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'rgb(222 222 222)'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? 'blue'
                  : 'green',
              color:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'black'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? '#fff'
                  : '#fff'
            }"
          >
            {{
              mainItem.MXLIST[0].XMJC +
                "(" +
                mainItem.MXLIST[0].SSLXMC +
                ")" +
                mainItem.MXLIST[0].TITLE
            }}
          </div>
          <div style="border-bottom: 1px dashed #ddd;">
            <van-row>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 23px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].TEAMMARK1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="padding-top: 10px;padding-bottom: 5px;font-size: 15px;text-align: center;"
                >
                  {{ "共" + mainItem.MXLIST.length + "场" }}
                </div>
                <div
                  v-bind:style="{
                    paddingBottom: '5px',
                    fontSize: '15px',
                    textAlign: 'center',
                    fontWeight: '600',
                    color:
                      mainItem.MXLIST[0].ISKS == '1'
                        ? 'blue'
                        : mainItem.MXLIST[0].ISKS == '2'
                        ? 'green'
                        : 'red'
                  }"
                >
                  {{
                    mainItem.MXLIST[0].ISKS == "1"
                      ? "正在比赛"
                      : mainItem.MXLIST[0].ISKS == "2"
                      ? "比赛完成"
                      : "未开赛"
                  }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 23px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].TEAMMARK2 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div style="padding-bottom: 10px;border-bottom: 5px solid #ddd;">
            <van-row>
              <van-col span="9">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].RYXM1 }}({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH1
                      : mainItem.MXLIST[0].ZNWZH1
                  }})
                </div>
                <div
                  v-if="mainItem.MXLIST[0].LQRMDCOUNT1 == '0'"
                  style="text-align: center;padding-top: 5px;color: red;font-size: 14px;font-weight: 600;"
                >
                  未填写名单
                </div>
              </van-col>
              <van-col span="6">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  VS
                </div>
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].BCYS }}
                  <span style="font-size:10px">分钟</span>
                </div>
              </van-col>
              <van-col span="9">
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].RYXM2 }}({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH2
                      : mainItem.MXLIST[0].ZNWZH2
                  }})
                </div>
                <div
                  v-if="mainItem.MXLIST[0].LQRMDCOUNT2 == '0'"
                  style="text-align: center;padding-top: 5px;color: red;font-size: 14px;font-weight: 600;"
                >
                  未填写名单
                </div>
              </van-col>
            </van-row>
          </div>
          <div
            style="padding-top: 5px;padding-bottom: 5px;"
            v-for="(mxItem, mxIndex) in mainItem.MXLIST"
            :key="mxIndex"
          >
            <van-row
              v-bind:style="{
                padding: '15px',
                background:
                  mxItem.TEAMISKS == '1'
                    ? '#9c6500'
                    : mxItem.TEAMISKS == '2'
                    ? 'green'
                    : '#8a8a8a',
                color:
                  mxItem.TEAMISKS == '1'
                    ? '#fff'
                    : mxItem.TEAMISKS == '2'
                    ? '#fff'
                    : '#fff'
              }"
            >
              <van-col span="12">
                <div style="padding-bottom: 10px;font-size: 14px;">
                  项目：{{ mxItem.TEAMSSLXMC }}({{ mxItem.TEAMSSLX }})
                </div>
                <div style="font-size: 14px;">
                  {{
                    mxItem.TEAMISKS == "1"
                      ? "正在比赛"
                      : mxItem.TEAMISKS == "2"
                      ? "比赛完成"
                      : mainItem.MXLIST[0].ISKS == "2"
                      ? "无效比赛"
                      : "未开赛"
                  }}({{ "第" + (mxIndex + 1) + "场" }})
                </div>
                <div
                  style="margin-top:6px;font-size: 14px;"
                  v-if="mainItem.MXLIST[0].XGCS > -1"
                >
                  您前面还有
                  <span style="color:#22ff08;">{{
                    mainItem.MXLIST[0].XGCS
                  }}</span>
                  场比赛
                </div>
                <div
                  style="margin-top:6px;font-size: 14px;color:#22ff08;"
                  v-if="
                    mainItem.MXLIST[0].XGCS > -1 && mainItem.MXLIST[0].XGCS < 5
                  "
                >
                  *请注意比赛时间及时检录*
                </div>
              </van-col>
              <van-col span="12">
                <div
                  style="font-size: 14px;padding-bottom: 3px;text-align: right;"
                >
                  {{ mainItem.MXLIST[0].RQ }}
                  {{
                    mainItem.MXLIST[0].STARTTIME == "-"
                      ? ""
                      : mainItem.MXLIST[0].STARTTIME
                  }}
                </div>
                <div
                  v-if="mxItem.CXDZH && mxItem.CXDZH.length > 0"
                  style="font-size: 14px;padding-bottom: 3px;text-align: right;"
                >
                  场序:{{ mxItem.CXDZH }}
                </div>
                <div>
                  <div
                    v-if="mxItem.CDH && mxItem.CDH.length > 0"
                    style="font-size: 14px;padding-bottom: 3px;text-align: right;"
                  >
                    {{ mxItem.CDH }}号场地
                  </div>
                </div>
              </van-col>
            </van-row>
            <van-row style="padding:15px;border-bottom: 5px solid #ddd;">
              <van-col span="8">
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 != '0' &&
                      mainItem.MXLIST[0].LQRMDCOUNT2 != '0'
                  "
                >
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ mxItem.TEAMRYXM1 }}
                  </div>
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ mxItem.TEAMRYXM2 }}
                  </div>
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 == '0' ||
                      mainItem.MXLIST[0].LQRMDCOUNT2 == '0'
                  "
                  style="text-align: center;font-size: 17px;"
                >
                  **
                </div>
                <div
                  style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mxItem.MARK1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  v-bind:style="{
                    textAlign: 'center',
                    paddingBottom: '5px',
                    color: mxItem.TEAMISKS == '1' ? 'blue' : 'black'
                  }"
                  v-for="(fxmxItem, fsmxIndex) in mxItem.CJLIST"
                  :key="fsmxIndex"
                >
                  {{ fxmxItem.MXMARK1 }}:{{ fxmxItem.MXMARK2 }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 != '0' &&
                      mainItem.MXLIST[0].LQRMDCOUNT2 != '0'
                  "
                >
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ mxItem.TEAMRYXM3 }}
                  </div>
                  <div
                    style="text-align: center;font-size: 16px;font-weight: 600;padding-bottom: 5px;"
                  >
                    {{ mxItem.TEAMRYXM4 }}
                  </div>
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].LQRMDCOUNT1 == '0' ||
                      mainItem.MXLIST[0].LQRMDCOUNT2 == '0'
                  "
                  style="text-align: center;font-size: 17px;"
                >
                  **
                </div>
                <div
                  style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mxItem.MARK2 }}
                </div>
              </van-col>
            </van-row>
          </div>
        </div>
        <!-- 团体赛 结束 -->
      </div>
      <div v-if="mainItem.MXLIST[0].SSLXTYPE !== 'T'">
        <!-- 单项赛 开始 -->
        <div
          style="background: #fff;margin-left: 10px;margin-right: 10px;margin-top: 20px;border-radius: 5px;"
        >
          <div
            class="titleMainClass"
            v-bind:style="{
              background:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'rgb(222 222 222)'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? 'blue'
                  : 'green',
              color:
                mainItem.MXLIST[0].ISKS === '0'
                  ? 'black'
                  : mainItem.MXLIST[0].ISKS === '1'
                  ? '#fff'
                  : '#fff'
            }"
          >
            {{ mainItem.MXLIST[0].XMJC }}（{{ mainItem.MXLIST[0].SSLXMC }}）
            {{ mainItem.MXLIST[0].TITLE }}
          </div>
          <div style="border-bottom: 1px dashed #ddd;">
            <van-row>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 10px;font-size: 23px;font-weight: 600;padding-bottom:6px;"
                >
                  {{ mainItem.MXLIST[0].MARK1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div style="text-align: center;">
                  {{ "共" + mainItem.MXLIST[0].JS + "局" }}
                </div>
                <div
                  v-bind:style="{
                    paddingBottom: '5px',
                    fontSize: '15px',
                    textAlign: 'center',
                    fontWeight: '600',
                    color:
                      mainItem.MXLIST[0].ISKS == '1'
                        ? 'blue'
                        : mainItem.MXLIST[0].ISKS == '2'
                        ? 'green'
                        : 'red'
                  }"
                >
                  {{
                    mainItem.MXLIST[0].ISKS == "1"
                      ? "正在比赛"
                      : mainItem.MXLIST[0].ISKS == "2"
                      ? "比赛完成"
                      : "未开赛"
                  }}
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;padding-top: 10px;font-size: 23px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].MARK2 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div style="padding-top: 5px;padding-bottom: 5px;">
            <van-row style="padding:15px;border-bottom: 1px solid #ddd;">
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].DWJC1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div style="text-align: center;padding-bottom: 5px;">
                  队伍名称
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].DWJC2 }}
                </div>
              </van-col>
            </van-row>
          </div>
          <div style="padding-top: 5px;padding-bottom: 5px;">
            <van-row style="padding:15px;border-bottom: 1px solid #ddd;">
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM1 }}
                </div>
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM2 }}
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].TEAMRYXM_FIN1 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN1.length > 0 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN1 !== '-'
                  "
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM_FIN1 }}
                </div>
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  （{{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH1
                      : mainItem.MXLIST[0].ZNWZH1
                  }})
                </div>
              </van-col>
              <van-col span="8">
                <div style="text-align: center;padding-bottom: 5px;">VS</div>
                <div
                  style="text-align: center;padding-top: 15px;font-size: 17px;font-weight: 600;"
                >
                  {{ mainItem.MXLIST[0].BCYS }}
                  <span style="font-size:10px">分钟</span>
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM3 }}
                </div>
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM4 }}
                </div>
                <div
                  v-if="
                    mainItem.MXLIST[0].TEAMRYXM_FIN2 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN2.length > 0 &&
                      mainItem.MXLIST[0].TEAMRYXM_FIN2 !== '-'
                  "
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ mainItem.MXLIST[0].TEAMRYXM_FIN2 }}
                </div>
                <div
                  style="text-align: center;font-size: 15px;font-weight: 600;padding-bottom: 5px;"
                >
                  ({{
                    mainItem.MXLIST[0].SSZL == "XH"
                      ? mainItem.MXLIST[0].ZHID +
                        "组" +
                        mainItem.MXLIST[0].ZNWZH2
                      : mainItem.MXLIST[0].ZNWZH2
                  }})
                </div>
              </van-col>
            </van-row>
            <van-row
              style="padding:15px;border-bottom: 1px solid #ddd;"
              v-for="(cjItem, cjIndex) in mainItem.MXLIST[0].CJLIST"
              :key="cjIndex"
            >
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ cjItem.MXMARK1 }}
                </div>
              </van-col>
              <van-col span="8">
                <div style="text-align: center;padding-bottom: 5px;">
                  第{{ cjItem.JSSXH }}局
                </div>
              </van-col>
              <van-col span="8">
                <div
                  style="text-align: center;font-size: 19px;font-weight: 600;padding-bottom: 5px;"
                >
                  {{ cjItem.MXMARK2 }}
                </div>
              </van-col>
            </van-row>
            <van-row
              style="padding-left: 15px;padding-right:15px;padding-top:6px"
            >
              <van-col span="15">
                <div
                  style="font-size: 15px;font-weight: 600;padding-bottom: 3px;text-align: left;"
                >
                  {{ mainItem.MXLIST[0].RQ }}
                  {{
                    mainItem.MXLIST[0].STARTTIME == "-"
                      ? ""
                      : mainItem.MXLIST[0].STARTTIME
                  }}
                  <div v-if="mainItem.MXLIST[0].CXDZH.length > 0">
                    &nbsp;&nbsp;场序:{{ mainItem.MXLIST[0].CXDZH }}
                  </div>
                </div>
              </van-col>
              <van-col span="9">
                <div
                  v-if="ISSHOWCDH === '1' && mainItem.MXLIST[0].CDH.length > 0"
                  style="font-size: 15px;font-weight: 600;padding-bottom: 3px;text-align: right;"
                >
                  {{ mainItem.MXLIST[0].CDH }}号场地
                </div>
                <div
                  v-else
                  style="font-size: 15px;font-weight: 600;padding-bottom: 3px;text-align: right;color:red"
                >
                  未公布场地号
                </div>
              </van-col>
            </van-row>
            <van-row v-if="false">
              <div
                style="font-size: 15px;font-weight: 600;padding-bottom: 3px;text-align: left;padding-left:15px"
              >
                场次号:{{ mainItem.CCH }}
              </div>
            </van-row>
          </div>
          <van-row
            v-if="mainItem.MXLIST[0].XGCS > -1"
            style="border-top: 1px solid #ddd;padding-top:10px;padding-bottom:5px;"
          >
            <div
              style="font-size: 14px;font-weight: 600;padding-bottom: 3px;text-align: left;padding-left:15px"
            >
              您前面还有
              <span style="font-size:16px;color:red;">
                {{ mainItem.MXLIST[0].XGCS }} </span
              >场比赛
              <span
                style="color:red;font-szie:16px;margin-left:6px;"
                v-if="
                  mainItem.MXLIST[0].XGCS > -1 && mainItem.MXLIST[0].XGCS < 6
                "
              >
                *请注意比赛时间及时检录*
              </span>
            </div>
          </van-row>
        </div>
        <!-- 单项赛 结束 -->
      </div>
    </div>

    <!--底部导航栏  开始-->
    <van-tabbar>
      <van-tabbar-item
        ><van-button round type="warning" @click="refshData">
          实时比分已连接
        </van-button></van-tabbar-item
      >
    </van-tabbar>
    <!--底部导航栏  结束-->
    <div style="height:150px;width:15px;"></div>
    <loading-com></loading-com>
  </div>
</template>

<script>
import LoadingCom from "../commonCom/LoadingCom.vue";
import allParam from "../../allParam/allParam.vue";
export default {
  name: "SsbfMxIndex",
  components: { LoadingCom, allParam },
  data() {
    return {
      otimer: "",
      utilPost: "",
      ssid: "",
      cdhActive: "",
      dataList: [],
      isEndPage: false,
      pageSet: {
        currentPage: 1, //当前页页码
        totalNums: 0 //数据总条数
      },

      search: {
        info: "",
        sslx: "",
        bszt: "",
        cdh: "",
        cch: "",
        sxh: ""
      },
      routeValue: "",
      /**socket 通讯 开始 */
      websock: null, //建立的连接
      lockReconnect: false, //是否真正建立连接
      timeout: 3 * 1000, //35秒一次心跳
      timeoutObj: null, //心跳心跳倒计时
      serverTimeoutObj: null, //心跳倒计时
      timeoutnum: null, //断开 重连倒计时
      socketTimer: null,
      /**socket 通讯 结束 */
      openIdEn: "",
      ISSHOWCDH: "1",
      loadDebounceTimer: null,
      isLoadingMainData: false,
      hasPendingRefresh: false
    };
  },
  created() {
    this.utilPost = this.$util.handler;
    this.ssid = this.$route.query.ssid;
    this.search.cch = this.$route.query.cch;
    this.search.sxh = this.$route.query.sxh;
  },
  destroyed: function() {
    //页面销毁时关闭长连接
    this.websocketclose();
    clearInterval(this.socketTimer);
  },
  mounted() {
    var routeValue = localStorage.getItem("routeValue");
    this.routeValue = routeValue;
    var that = this;
    var openIdEn = localStorage.getItem("openIdEn");
    if (openIdEn === undefined || openIdEn === null || openIdEn.length === 0) {
      this.utilPost.getOpenId(function(openId) {
        that.openIdEn = openId;
      });
    } else {
      this.openIdEn = openIdEn;
    }
    this.dataList = [];
    //必须等界面渲染完成后 在加载
    this.mainData();
    this.initWebSocket();
    //开启计时器
    //每5秒查询一次
    // this.otimer = setInterval(() => {
    //   console.log("主动查询");
    //   var busData = {
    //     pageSet: this.pageSet,
    //     search: this.search
    //   };
    //   var paramData = {
    //     headerData: {
    //       ssid: this.ssid,
    //       op: "wapGL", //反射名称
    //       methodName: "getSsbfData" //对应的方法名
    //     },
    //     busData: busData //参数内容
    //   };
    //   this.utilPost.paramData = paramData;
    //   this.utilPost.sendPostNoLoading().then(data => {
    //     //console.log(data);
    //     //alert(JSON.stringify(data));
    //     if (!data.isSuccess) {
    //       alert(data.msg);
    //       return;
    //     }

    //     this.dataList = data.content.DATALIST;
    //   });
    // }, 60000);
    // this.$once("hook:beforeDestroy", () => {
    //   //页面关闭
    //   console.log("计时器关闭");
    //   clearInterval(this.otimer); //停止
    // });
  },
  methods: {
    scheduleMainLoad() {
      console.log("ttttttt");
      this.hasPendingRefresh = true;
      if (this.loadDebounceTimer) {
        clearTimeout(this.loadDebounceTimer);
      }
      this.loadDebounceTimer = setTimeout(async () => {
        // 若正在请求，等它结束后再补一次
        if (this.isLoadingMainData) return;
        this.isLoadingMainData = true;
        this.hasPendingRefresh = false;
        try {
          const now = new Date();
          const pad = n => String(n).padStart(2, "0");
          const timeStr =
            `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(
              now.getDate()
            )} ` +
            `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(
              now.getSeconds()
            )}`;
          console.log("接口访问执行时间：" + timeStr);
          await this.mainDataNoLoading();
        } finally {
          this.isLoadingMainData = false;
          // 请求期间若又来了消息，可补发一次
          if (this.hasPendingRefresh) {
            this.scheduleMainLoad();
          }
        }
      }, 30000); // 15秒窗口
    },
    searchHandler() {
      this.dataList = [];
      this.pageSet.currentPage = 1;
      this.mainData();
    },
    refshData() {
      this.dataList = [];
      this.mainData();
    },
    mainData() {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getSsbfData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPost().then(data => {
        //console.log(data);
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }
        this.ISSHOWCDH = data.lsData.ISSHOWCDH;
        this.dataList = data.content.DATALIST;
      });
    },
    //打开比赛状态Model
    onTopClickLeft() {
      this.$router.go(-1);
    },
    /**webSocket 开始 */
    mainDataNoLoading() {
      var busData = {
        pageSet: this.pageSet,
        search: this.search
      };
      var paramData = {
        headerData: {
          ssid: this.ssid,
          op: "wapGL", //反射名称
          methodName: "getSsbfData" //对应的方法名
        },
        busData: busData //参数内容
      };
      this.utilPost.paramData = paramData;
      this.utilPost.sendPostNoLoading().then(data => {
        //console.log(data);
        //alert(JSON.stringify(data));
        if (!data.isSuccess) {
          alert(data.msg);
          return;
        }

        this.dataList = data.content.DATALIST;
      });
    },
    StringToHex(str) {
      if (str == "") return "";
      let hex = [];
      //hex.push("0x");
      for (var i = 0; i < str.length; i++) {
        hex.push(str.charCodeAt(i).toString(16));
      }
      return hex.join("");
    },
    initWebSocket() {
      //建立连接
      //初始化weosocket
      //const wsuri = "ws://sms.填写您的地址.com/websocket/" + this.charId; //ws地址
      var dt = new Date();
      let year = dt.getFullYear();
      let month = (dt.getMonth() + 1).toString().padStart(2, "0");
      let date = dt
        .getDate()
        .toString()
        .padStart(2, "0");
      var paramWebSocket = year + month + date;
      var rsaData = this.utilPost.rsaEn(
        paramWebSocket + "|spjaSGGOv6OtzioNsfOZWAt6DL5LnlNz"
      );
      const wsuri =
        allParam.wapSocketUrl +
        "/" +
        this.ssid +
        "/" +
        encodeURIComponent(this.StringToHex(rsaData)) +
        "/" +
        this.openIdEn;
      //建立连接
      this.websock = new WebSocket(wsuri);
      //连接成功
      this.websock.onopen = event => {
        this.websocketonopen();
      };
      //连接错误
      this.websock.onerror = event => {
        this.websocketonerror(event);
      };
      //接收信息
      this.websock.onmessage = event => {
        this.websocketonmessage(event);
      };
      //连接关闭
      this.websock.onclose = event => {
        this.websocketclose(event);
      };
    },
    reconnect() {
      //重新连接
      var that = this;
      if (that.lockReconnect) {
        return;
      }
      that.lockReconnect = true;
      //没连接上会一直重连，设置延迟避免请求过多
      that.timeoutnum && clearTimeout(that.timeoutnum);
      that.timeoutnum = setTimeout(function() {
        //新连接
        that.initWebSocket();
        that.lockReconnect = false;
      }, 5000);
    },
    reset() {
      //重置心跳
      var that = this;
      //清除时间
      clearTimeout(that.timeoutObj);
      clearTimeout(that.serverTimeoutObj);
      //重启心跳
      that.start();
    },
    start() {
      //开启心跳
      var self = this;
      clearInterval(this.socketTimer);
      this.socketTimer = setInterval(() => {
        console.log("重发心跳，状态" + self.websock.readyState);
        //重发心跳时  重新获取数据
        //这里发送一个心跳，后端收到后，返回一个心跳消息，
        if (self.websock.readyState == 1) {
          //如果连接正常
          self.websock.send("heartCheck");
        } else {
          //否则重连
          self.reconnect();
        }
      }, 30000);
    },

    websocketonopen() {
      //连接成功事件

      //提示成功
      console.log("连接成功");
      //开启心跳
      this.start();
    },

    websocketonerror(e) {
      //连接失败事件
      //错误
      console.log("WebSocket连接发生错误");
      //重连
      this.reconnect();
    },
    websocketclose(e) {
      //连接关闭事件
      //关闭
      console.log("关闭连接");
      //重连
      // this.reconnect();
      if (this.websock) {
        this.websock.close();
        console.log("WebSocket连接已关闭");
      }
    },
    byteToString(arr) {
      if (typeof arr === "string") {
        return arr;
      }
      var str = "",
        _arr = arr;
      for (var i = 0; i < _arr.length; i++) {
        var one = _arr[i].toString(2),
          v = one.match(/^1+?(?=0)/);
        if (v && one.length == 8) {
          var bytesLength = v[0].length;
          var store = _arr[i].toString(2).slice(7 - bytesLength);
          for (var st = 1; st < bytesLength; st++) {
            store += _arr[st + i].toString(2).slice(2);
          }
          str += String.fromCharCode(parseInt(store, 2));
          i += bytesLength - 1;
        } else {
          str += String.fromCharCode(_arr[i]);
        }
      }
      return str;
    },
    websocketonmessage(event) {
      //接收服务器推送的信息
      setTimeout(() => {
        // console.log("socket接收的：", event.data);
        var signRes = this.utilPost.verifySign(event.data);
        if (!signRes.isSign) {
          return;
        }
        var resultJob = JSON.parse(signRes.jsonMsg);
        var CJLIST = resultJob.CJLIST;
        var socketXMID = resultJob.XMID;
        var socketCCH = resultJob.CCH;
        var socketSSID = resultJob.SSID;
        var socketSXH = resultJob.SXH + "";
        for (var i = 0; i < this.dataList.length; i++) {
          var itemMain = this.dataList[i];
          var MXLIST = itemMain.MXLIST;
          for (var j = 0; j < MXLIST.length; j++) {
            var itemData = MXLIST[j];
            var sslxType = itemData.SSLX.substr(1, 2);

            var dataXMID = itemData.XMID;
            var dataCCH = itemData.CCH;
            var dataSXH = itemData.SXH + "";
            var dataSSID = itemData.SSID;
            if (
              dataSSID === socketSSID &&
              dataXMID === socketXMID &&
              dataCCH === socketCCH &&
              dataSXH === socketSXH
            ) {
              //将比赛状态改成比赛中
              if (sslxType === "T") {
                itemData.TEAMISKS = "1";
              } else {
                itemData.TEAMISKS = "1";
                itemData.ISKS = "1";
              }

              if (CJLIST.length === 0) {
                //比赛完成了，从新加载界面
                this.scheduleMainLoad();
              } else {
                itemData.CJLIST = CJLIST;
              }
            }
          }
        }
      }, 10);

      // //收到服务器信息，心跳重置
      // this.reset();
    },
    websocketsend(msg) {
      //向服务器发送信息
      //数据发送
      this.websock.send(msg);
    }
    /**webSocket 结束 */
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.titleMainClass {
  text-align: center;
  padding: 10px;
  border-bottom: 1px solid rgb(221, 221, 221);
  font-size: 16px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  font-weight: 600;
}
/deep/.van-nav-bar {
  position: fixed;
  top: 0px;
  width: 100%;
}
/deep/ .van-tabs__nav {
  margin: 0px !important;
  border: 1px solid rgb(24, 95, 155) !important  ;
}
/deep/ .van-tab.van-tab--active {
  background-color: rgb(24, 95, 155) !important;
}
/deep/ .van-tab {
  border-right: 1px solid rgb(24, 95, 155);
  color: rgb(24, 95, 155);
}
/deep/ .van-cell--cente {
  padding: 6px !important;
}
.van-field {
  padding: 3px;
  border-radius: 5px;
}
.dropClass {
  background: #ffffff4f;
  padding: 8px;
  border-radius: 5px;
  font-size: 13px;
  color: #fff;
}
.van-overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.itemContentMain {
  background: #fff;
  margin: 10px;
  padding: 10px;
  border-radius: 5px;
  position: relative;
}
.van-image--round {
  margin-top: 15px;
}
.van-tag {
  font-size: 13px;
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 3px;
  padding-bottom: 3px;
}
.textMainDiv {
  padding-top: 15px;
}
.van-button--warning {
  width: 300px;
  height: 35px;
}
</style>



// WEBPACK FOOTER //
// src/components/SsbfIndex/SsbfMxIndex.vue